module.exports = __webpack_public_path__ + "img/sign-in-with-github.63d6b223.png";